import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { SubNavigation } from "@common/Navigation/SubNavigation";
import "@features/Bills/css/BillsPage.scss";
import { BillsHistoryList } from "@features/Bills/BillsHistoryList";
import { useGetAccountDetails } from "@features/AccountDetails/hook/useGetAccountDetails";
import { Grid, MenuItem, Select, Typography } from "@mui/material";

export const BillsPage = () => {
    const monthIntervalList = [3, 6, 12];
    const { accountDetails } = useGetAccountDetails();
    const accountId = accountDetails?.id;

    const [monthInterval, setMonthInterval] = useState(monthIntervalList[0]);
    const { t } = useTranslation(["navigation", "bills", "glossary"]);

    return (
        <Fragment>
            <SubNavigation />
            <div className="container-boxed">
                <Typography align="center" className="container-boxed__title" color="secondary" variant="h1">
                    {t("navigation:myBills")}
                </Typography>
                <Grid
                    alignItems="center"
                    className="bills-history__header"
                    container
                    justifyContent="space-between"
                    spacing={2}
                >
                    <Grid item sm="auto" xs={6}>
                        <Typography align="left" color="primary" variant="h2">
                            {t("bills:history")}
                        </Typography>
                        <Typography color="primary" variant="normal">
                            {t("bills:monthlyBillCharges")}
                        </Typography>
                    </Grid>
                    <Grid item sm="auto" xs={6}>
                        <Select
                            aria-label="Select month filter"
                            disableUnderline
                            fullWidth
                            id="history-helper"
                            value={monthInterval}
                            variant="filled"
                            onChange={(event) => setMonthInterval(parseInt(event.target.value as string))}
                        >
                            {monthIntervalList.map((month) => (
                                <MenuItem key={month} value={month}>
                                    {t("glossary:lastXMonths", { monthsNumber: month })}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                </Grid>
                {accountId && <BillsHistoryList accountId={accountId} monthInterval={monthInterval} />}
            </div>
        </Fragment>
    );
};
